import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, StethoscopeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-petrol pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-128" data-mp="129qvxpsonxpz">
      <div className="absolute inset-x-0 bottom-0 -z-10 h-40 bg-petrolDark" data-id="element-129" data-mp="xa4ef45tnvbd" />
      <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-aqua/25" data-id="element-130" data-mp="sb1c3rh88373" />
      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-131" data-mp="ncgk2fc4optq">
        <motion.p initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 rounded-full border border-aqua/40 bg-petrolDark px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-aqua" data-id="element-132" data-mp="nbyj55eitnfh">
          <StethoscopeIcon className="h-4 w-4" data-id="element-133" data-mp="3o7lrboupx2nw" /> Megapack Instrumentación Quirúrgica Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.08
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.04] text-white sm:text-6xl md:text-7xl" data-id="element-134" data-mp="39al9cd2bwm2m">
          Del instrumental al aula.<br data-id="element-135" data-mp="359t19n570n7x" />
          <span className="text-aqua" data-id="element-136" data-mp="359j9bu0l85zl">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-137" data-mp="2qkmtvbw7bqoy">
          <img src={productImage} alt="Megapack Instrumentación Quirúrgica Listo: seis tomos, cuatro bonos y dos módulos premium" className="mx-auto w-full drop-shadow-[0_24px_32px_rgba(0,0,0,.45)]" data-id="element-138" data-mp="2hjoux80me9d8" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-139" data-mp="nb1imyt8vhts">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-lineDark bg-petrolDark px-3 py-2" data-id="element-140" data-mp="ddf0m3gnfa5l">
              {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-141" data-mp="1ayt6mzo5djaw">
          <Button onClick={scrollToPricing} arrow data-id="element-142" data-mp="161axp9a4r42w">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-143" data-mp="112g7vndqwf9a">
          <span className="inline-flex items-center gap-1.5" data-id="element-144" data-mp="x1w6u8q1wrhv"><ShieldCheckIcon className="h-4 w-4 text-aqua" data-id="element-145" data-mp="x37am8jhxz8z" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="3lui70k7oini7"><LockIcon className="h-4 w-4 text-aqua" data-id="element-147" data-mp="3hrlosum1wtes" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="3htpzpwidasok"><CreditCardIcon className="h-4 w-4 text-aqua" data-id="element-149" data-mp="1xacgb5dntnua" /> Mercado Pago</span>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-mutedDark" data-id="element-150" data-mp="21a4tjve00i5z">
          <BadgeCheckIcon className="h-4 w-4 text-aqua" data-id="element-151" data-mp="269r39uumbga1" />
          <ZapIcon className="h-4 w-4 text-aqua" data-id="element-152" data-mp="2686aa9nyc5ea" /> Para docentes de Instrumentación Quirúrgica de toda Argentina
        </p>
      </div>
    </section>;
}